export const smsActionData = [
  {
    name: 'sendDynamicMessage',
    label: 'Send Dynamic Message',
    args: [
      {
        name: 'smsTemplate',
        label: 'SMS Template',
        type: 'dropdown',
        optionsType: 'smsTemplateApi',
        options: [],
        value: '',
      },
    ],
  },
];
